import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=63927b90&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"
import style0 from "./Card.vue?vue&type=style&index=0&id=63927b90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63927b90",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EventCardImage: require('/home/ticketshoplv/public_html/ticketshop.lt/components/Event/CardImage.vue').default})
